import { BASE_URL } from "../../../config";
import {
  setTokens,
  getUserInfo,
  getUserRoles,
} from "./auth";
import { toast } from "react-toastify";

export const loginUser = async (username, password, setUserInfo, setUserRoles, setIsLoggedIn, setShowLoginModal) => {
  const params = new URLSearchParams();
  params.append("client_id", "amg-client-mobile");
  params.append("grant_type", "password");
  params.append("username", username);
  params.append("password", password);
  params.append("scope", "openid");

  try {
    const response = await fetch(
      `${BASE_URL}/auth/realms/EK/protocol/openid-connect/token`,
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params,
      }
    );

    const result = await response.json();
    if (response.ok) {
      setTokens(result);
      const user = getUserInfo();
      setUserInfo({ name: user.given_name, surname: user.family_name });
      setUserRoles(user.realm_access.roles || []);
      setIsLoggedIn(true);
      setShowLoginModal(false);
      return true;
    } else {
      toast.error("Prijava nije uspela.");
      return false;
    }
  } catch (err) {
    console.error("Greška pri prijavi:", err);
    toast.error("Došlo je do greške pri prijavi.");
    return false;
  }
};
